module.exports = __webpack_public_path__ + "img/b1.46b54eca.png";